<script lang="ts">
    import type { Snippet } from "svelte";
    import { fly } from "svelte/transition";
    import ButtonClose from "../Input/ButtonClose.svelte";
    import { modals } from "@wa-modals";

    interface Props {
        isOpen?: boolean;
        withAction?: boolean;
        title?: Snippet;
        content?: Snippet;
        action?: Snippet;
    }

    let { isOpen = false, withAction = true, title, content, action }: Props = $props();
</script>

{#if isOpen}
    <div class="absolute flex items-center justify-center w-full h-full">
        <div
            class="pointer-events-auto left-0 right-0 z-[2001] m-auto max-h-full w-[90%] overflow-y-auto rounded-[var(--nutrivera-shell-radius)] border border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-bg)] text-[var(--nutrivera-shell-text)] shadow-[0_6px_8px_rgb(7_17_28/28%)] sm:max-w-[668px]"
            transition:fly={{ y: -1000, delay: 0, duration: 300 }}
        >
            <div class="p-8 flex flex-col justify-center items-center">
                <div class="flex-row flex items-start w-full justify-between gap-4">
                    <div class="p-2">
                        {@render title?.()}
                    </div>
                    <div>
                        <ButtonClose
                            dataTestId="closeModal"
                            onclick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                modals.close();
                            }}
                        />
                    </div>
                </div>
                {@render content?.()}
            </div>
            {#if withAction}
                <div
                    class="footer flex w-full flex-row items-center justify-evenly gap-3 border-t border-solid border-[var(--nutrivera-shell-border)] bg-[var(--nutrivera-shell-raised)] p-4"
                >
                    {@render action?.()}
                </div>
            {/if}
        </div>
    </div>
{/if}
